"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextInput = void 0;
const react_1 = __importStar(require("react"));
const TextInput_styles_1 = require("./TextInput.styles");
const TextInputComponent = (0, react_1.forwardRef)((_a, forwardedRef) => {
    var { children, isInvalid, spellCheck = "false" } = _a, props = __rest(_a, ["children", "isInvalid", "spellCheck"]);
    const inputRef = react_1.default.useRef(null);
    // This connects the inputRef to the forwardedRef so that both TextInput and the parent component can access the input element
    (0, react_1.useImperativeHandle)(forwardedRef, () => inputRef.current);
    // Focus the input when the user clicks on the TextInputSlots inside the TextInputWrapper
    // This is from https://github.com/radix-ui/themes/blob/main/packages/radix-ui-themes/src/components/text-field.tsx
    const handlePointerDown = (event) => {
        const target = event.target;
        if (target.closest("input, button, a"))
            return;
        const input = inputRef.current;
        if (!input)
            return;
        // If the user clicked on the right slot, move the cursor to the end
        const isRightSlot = target.closest(`[data-text-input-position='end']`);
        const cursorPosition = isRightSlot ? input.value.length : 0;
        requestAnimationFrame(() => {
            // Only some input types support this, browsers will throw an error if not supported
            try {
                input.setSelectionRange(cursorPosition, cursorPosition);
            }
            catch (_a) {
                /* If it's not supported just focus */
            }
            input.focus();
        });
    };
    return (react_1.default.createElement(TextInput_styles_1.StyledTextInputWrapper, { onPointerDown: handlePointerDown, "$isInvalid": isInvalid, "$disabled": props.disabled },
        react_1.default.createElement(TextInput_styles_1.StyledTextInput, Object.assign({ ref: inputRef, spellCheck: spellCheck, "aria-invalid": isInvalid }, props)),
        children));
});
const TextInputSlot = (0, react_1.forwardRef)((_a, forwardedRef) => {
    var { children, position } = _a, props = __rest(_a, ["children", "position"]);
    return (react_1.default.createElement(TextInput_styles_1.StyledTextInputSlot, Object.assign({ ref: forwardedRef, "$position": position }, props, { "data-text-input-position": position }), children));
});
TextInputComponent.displayName = "TextInput";
TextInputSlot.displayName = "TextInputSlot";
const TextInput = Object.assign(TextInputComponent, {
    Slot: TextInputSlot,
});
exports.TextInput = TextInput;
//# sourceMappingURL=TextInput.js.map